




































import { Component, Vue } from 'vue-property-decorator';
import PurchaseService from '@/services/purchase';
import Purchase from '@/entities/Purchase';
import ModalService from '@/services/modal';

@Component
export default class Purchases extends Vue {
    purchaseService = new PurchaseService();

    modalService = new ModalService();

    get purchases(): Purchase[] {
        return this.purchaseService.list;
    }

    remove(purchase: Purchase) {
        this.modalService.showConfirmationModal(
            'Are you sure?',
            'You are about to cancel a purchase. Please confirm, as this is irrevertable!',
            () => this.doRemove(purchase),
        );
    }

    doRemove(purchase: Purchase) {
        this.purchaseService
            .remove(purchase);
    }
}
